import { render } from "./Error403.vue?vue&type=template&id=57d4180d&scoped=true&ts=true"
import script from "./Error403.vue?vue&type=script&lang=ts"
export * from "./Error403.vue?vue&type=script&lang=ts"

import "./Error403.vue?vue&type=style&index=0&id=57d4180d&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d4180d"]])

export default __exports__